import React from 'react';
import ResultPageModalButtons from '../../../common/components/redesignComponents/ResultPageComponents/ResultPageModalButtons';
import { safeCapitalizeWords } from '../../../common/constants';

function HouseModalButtons({
  insuranceRequest,
  processingQuote,
  type,
  riskQuotations,
  removeItemFromCart,
  quotations,
}) {
  const getQuoteTypeNameForResCivile = () => {
    if (type.id === 'res_civile' && insuranceRequest.product.id === 11) {
      const quote = quotations?.res_civile?.find((el) => el.company_id === 16);

      if (quote) {
        return safeCapitalizeWords(quote.product_name);
      }
      const nobisQuote = quotations?.res_civile?.find((el) => el.company_id === 1001);

      if (nobisQuote) {
        return safeCapitalizeWords(nobisQuote.product_name);
      }
    }

    return safeCapitalizeWords(type.name);
  };

  const title = type.id === 'res_civile' ? getQuoteTypeNameForResCivile() : safeCapitalizeWords(type.name);

  return (
    <ResultPageModalButtons
      insuranceRequest={insuranceRequest}
      processingQuote={processingQuote}
      type={type}
      riskQuotations={riskQuotations}
      removeItemFromCart={removeItemFromCart}
      title={title}
      selectFirstLabel="Quotazione Principale"
      excludedCompanyIds={[8, 16]}
    />
  );
}

export default HouseModalButtons;
